import React from "react";
import { Row, Col, Form, Input, Select, DatePicker, Switch } from "antd";
import { UserOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import data from "../../../../constants/retailPos.json";
import { getMultilingualText } from "../../../../utils/getMultilingualText";

const { Option } = Select;

/**
 * Fallback form UI rendered when no dynamic retailCustomerFields are configured.
 * Shows two tabs — Contact (name/email/mobile/pincode) and Details (address/loyalty/general info).
 */
const LegacyContactForm = ({
  form,
  cart,
  selectedEditOldCustomer,
  posConfig,
  loyalityType,
  enableLoyality,
  onSwitchChange,
  toggleCustomer,
  setToggleCustomer,
  open,
  showVirtualKeyboard,
  refs,
  getInputValue,
  onChangeInput,
  onFocusInput,
  keyboardInputFields,
  setKeyboardInputFields,
  keyboard,
  renderThumb,
  renderThumbHorizontalScroll,
}) => {
  return (
    <>
      <Row
        style={{
          backgroundColor: "#f5f5f5",
          padding: "6px",
          borderRadius: "8px",
          marginTop: "2vh",
          height: "7vh",
          display: "flex",
        }}
      >
        <Col
          onClick={() => setToggleCustomer(false)}
          style={{
            flex: 1,
            padding: "6px 0",
            borderRadius: "6px",
            backgroundColor: !toggleCustomer ? "#fff" : "transparent",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
            color: !toggleCustomer ? "#000" : "#8c8c8c",
            fontWeight: !toggleCustomer ? 600 : 500,
            boxShadow: !toggleCustomer ? "0px 0px 4px rgba(0,0,0,0.05)" : "none",
            transition: "all 0.2s ease",
          }}
        >
          <UserOutlined /> {getMultilingualText("Contact")}
        </Col>

        <Col
          onClick={() => setToggleCustomer(true)}
          style={{
            flex: 1,
            padding: "6px 0",
            borderRadius: "6px",
            backgroundColor: toggleCustomer ? "#fff" : "transparent",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
            color: toggleCustomer ? "#000" : "#8c8c8c",
            fontWeight: toggleCustomer ? 600 : 500,
            boxShadow: toggleCustomer ? "0px 0px 4px rgba(0,0,0,0.05)" : "none",
            transition: "all 0.2s ease",
          }}
        >
          <InfoCircleOutlined /> {getMultilingualText("Details")}
        </Col>
      </Row>

      <Scrollbars
        renderThumbHorizontal={renderThumbHorizontalScroll}
        renderThumbVertical={renderThumb}
        style={{ height: open && showVirtualKeyboard ? "20vh" : "66vh" }}
      >
        {/* ── Details tab ─────────────────────────────────────── */}
        <div style={{ display: toggleCustomer ? "block" : "none", overflowX: "hidden" }}>
          <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.35)", marginTop: "1.5vh" }}>
            <Col span={24} style={{ fontSize: "1vw" }}>
              <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", marginTop: "2vh", color: "#0F0718" }}>
                {getMultilingualText("MAILING ADDRESS")}
              </label>
            </Col>
          </Row>

          <Row>
            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Street")}</label>
              <Form.Item form={form} name="street" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                <Input
                  ref={refs.street}
                  onFocus={() => onFocusInput("street")}
                  value={getInputValue("street")}
                  onChange={onChangeInput}
                  id="sm-product-search"
                  className="customerDetailsInput"
                  placeholder="Street"
                  style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("City")}</label>
              <Form.Item form={form} name="city" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                <Input
                  ref={refs.city}
                  value={getInputValue("city")}
                  onChange={onChangeInput}
                  onFocus={() => onFocusInput("city")}
                  id="sm-product-search"
                  className="customerDetailsInput"
                  placeholder="City"
                  style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("State")}</label>
              <Form.Item name="state" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                <Input
                  readOnly
                  onFocus={() => onFocusInput("state")}
                  value={getInputValue("state")}
                  onChange={onChangeInput}
                  id="sm-product-search"
                  className="customerDetailsInput"
                  placeholder="Enter State"
                  style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Country")}</label>
              <Form.Item name="country" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                <Input
                  readOnly
                  onFocus={() => onFocusInput("country")}
                  value={getInputValue("country")}
                  onChange={onChangeInput}
                  id="sm-product-search"
                  className="customerDetailsInput"
                  placeholder="Enter Country"
                  style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Pincode")}</label>
              <Form.Item form={form} name="pincode" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                <Input
                  ref={refs.pincode}
                  value={getInputValue("pincode")}
                  onChange={onChangeInput}
                  onFocus={() => onFocusInput("pincode")}
                  id="sm-product-search"
                  className="customerDetailsInput"
                  placeholder="Enter Pincode"
                  style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row
            style={{
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              marginBottom: "1.5vh",
              width: "80.2vw",
              fontSize: "1vw",
            }}
          >
            <Col span={24} style={{ marginTop: "2.5vh" }}>
              <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>LOYALTY</label>
            </Col>
          </Row>

          <Row>
            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh", fontSize: "1vw" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Loyalty</label>
              <Form.Item name="loyality" valuePropName="checked" style={data.posScreenStyles.addEditCustomerModal.formItem} initialValue={true}>
                <Switch onChange={onSwitchChange} defaultChecked />
                <span style={{ fontFamily: "Inter", fontSize: "1em", fontWeight: 500, paddingTop: "0.5vh", color: "#0F0718" }}>
                  Enable loyalty for this customer
                </span>
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh", fontSize: "1vw" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Program</label>
              {enableLoyality && (
                <Form.Item name="program" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                  <Select disabled={true} style={{ width: "27.5vw", height: "7vh" }}>
                    <Option key={loyalityType[0]?.loyaltylevelId} value={loyalityType[0]?.loyaltylevelId}>
                      {loyalityType[0]?.name}
                    </Option>
                  </Select>
                </Form.Item>
              )}
            </Col>
          </Row>

          <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)", marginBottom: "2vh", width: "80.2vw", fontSize: "1vw" }}>
            <Col span={24}>
              <label style={{ fontSize: "1em", fontWeight: 500, letterSpacing: "1.5px", color: "#0F0718" }}>GENERAL INFORMATION</label>
            </Col>
          </Row>

          <Row>
            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Anniversary Date</label>
              <Form.Item name="anniversaryDate" style={{ border: "0", height: "3vh" }}>
                <DatePicker
                  placeholder="DD/MM/YYYY"
                  className="cutomerDobInput"
                  format="DD/MM/YYYY"
                  style={{ height: "7.3vh", border: "none", marginTop: 10, width: "95%", border: "1px solid #d9d9d9" }}
                />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Tax ID</label>
              <Form.Item form={form} name="taxID" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                <Input
                  ref={refs.taxID}
                  value={getInputValue("taxID")}
                  onChange={onChangeInput}
                  onFocus={() => onFocusInput("taxID")}
                  id="sm-product-search"
                  className="customerDetailsInput"
                  placeholder="Tax ID"
                  style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Date of Birth</label>
              <Form.Item name="BirthdayDate" style={{ border: "0" }}>
                <DatePicker
                  placeholder="DD/MM/YYYY"
                  className="cutomerDobInput"
                  format="DD/MM/YYYY"
                  style={{ width: "95%", height: "7.3vh", margin: "10px 0", border: "1px solid #d9d9d9" }}
                />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh", fontSize: "1vw" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>Gender</label>
              <Form.Item name="gender" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                <Select size="large" style={{ border: "1px solid #d9d9d9", width: "28vw" }} className="genderSelect">
                  <Option key={"MAL"} value="MAL">Male</Option>
                  <Option key={"FEM"} value="FEM">Female</Option>
                  <Option key={"TRA"} value="TRA">Transgender</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          {/* Additional info section */}
          <div style={{ backgroundColor: "#fff", padding: "1vh 0", margin: "0 2vw 2vh 0", width: "80.6vw", fontSize: "1vw" }}>
            <p style={{ fontSize: "1.1em", margin: 0, fontWeight: "600", color: "#0F0718" }}>Additional Information</p>
            <Col span={24}>
              {[
                ["Last Visit Date", cart?.customer?.lastVisitDate ?? selectedEditOldCustomer?.lastVisitDate ?? "0"],
                ["No Of Visits", cart?.customer?.noOfVisits ?? selectedEditOldCustomer?.noOfVisits ?? "0"],
                ["Last Billing Amount", cart?.customer?.lastBillingAmount ?? selectedEditOldCustomer?.lastBillingAmount ?? "0"],
                ["Average Basket Value", cart?.customer?.averageBasketValue ?? selectedEditOldCustomer?.averageBasketValue ?? "0"],
                ["Loyalty Balance Points", cart?.customer?.retlLoyaltyBalance ?? selectedEditOldCustomer?.retlLoyaltyBalance ?? " "],
                ["Credit Balance", cart?.customer?.creditLimit ?? selectedEditOldCustomer?.creditLimit ?? " "],
              ].map(([label, value]) => (
                <Row key={label} style={{ padding: "3px 0" }}>
                  <Col span={12} className="addtInfo">{label}</Col>
                  <Col span={2}>:</Col>
                  <Col span={9} offset={1} className="addtInfo">{value}</Col>
                </Row>
              ))}
            </Col>
          </div>
        </div>

        {/* ── Contact tab ─────────────────────────────────────── */}
        <div style={{ display: toggleCustomer ? "none" : "block", fontSize: "1vw" }}>
          <Row>
            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("First Name")}</label>
              <Form.Item
                form={form}
                name="name"
                rules={[{ required: true, message: "Please Input First Name" }]}
                style={data.posScreenStyles.addEditCustomerModal.formItem}
              >
                <Input
                  ref={refs.name}
                  value={getInputValue("name")}
                  onChange={onChangeInput}
                  onFocus={() => onFocusInput("name")}
                  id="sm-product-search"
                  className="customerDetailsInput"
                  placeholder="First Name"
                  style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2.5vh" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Last Name")}</label>
              <Form.Item form={form} name="lastName" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                <Input
                  ref={refs.lastName}
                  value={getInputValue("lastName")}
                  onChange={onChangeInput}
                  onFocus={() => onFocusInput("lastName")}
                  id="sm-product-search"
                  className="customerDetailsInput"
                  placeholder="Last Name"
                  style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Email")}</label>
              <Form.Item form={form} name="email" style={data.posScreenStyles.addEditCustomerModal.formItem}>
                <Input
                  ref={refs.email}
                  value={getInputValue("email")}
                  onChange={onChangeInput}
                  onFocus={() => onFocusInput("email")}
                  id="sm-product-search"
                  className="customerDetailsInput"
                  placeholder="Enter Email"
                  style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Contact Number")}</label>
              <Form.Item
                name="mobile"
                form={form}
                rules={[
                  {
                    required: true,
                    validator: (_, value) => {
                      const lengthRaw = posConfig?.customerMobileNumberLength;
                      const lengthRequired = Number(lengthRaw);
                      const isLengthValidNumber =
                        !isNaN(lengthRequired) && Number.isInteger(lengthRequired) && lengthRequired > 0;
                      if (!value) return Promise.reject("Please Input Contact Number");
                      if (!/^[0-9]+$/.test(value)) return Promise.reject("Only digits are allowed");
                      if (isLengthValidNumber && value.length !== lengthRequired) {
                        return Promise.reject(`Mobile number must be exactly ${lengthRequired} digits`);
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
                style={data.posScreenStyles.addEditCustomerModal.formItem}
              >
                <Input
                  ref={refs.mobile}
                  value={getInputValue("mobile")}
                  onChange={(event) => {
                    const inputVal = event.target.value.replace(/\D/g, "");
                    const lengthRaw = posConfig?.customerMobileNumberLength;
                    const maxLen = Number(lengthRaw);
                    const isLengthValidNumber = !isNaN(maxLen) && Number.isInteger(maxLen) && maxLen > 0;
                    if (!isLengthValidNumber || inputVal.length <= maxLen) {
                      setKeyboardInputFields({ ...keyboardInputFields, mobile: inputVal });
                      form.setFieldsValue({ mobile: inputVal });
                      keyboard?.current?.setInput(inputVal);
                    }
                  }}
                  onFocus={() => onFocusInput("mobile")}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) event.preventDefault();
                  }}
                  id="sm-product-search"
                  className="customerDetailsInput"
                  placeholder="Enter Contact Number"
                  style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                  maxLength={posConfig?.customerMobileNumberLength}
                />
              </Form.Item>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }} style={{ marginTop: "2vh" }}>
              <label style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsField}>{getMultilingualText("Pincode")}</label>
              <Form.Item
                name="pincode"
                form={form}
                rules={[{ required: false, pattern: new RegExp(/\d+/g), message: "Please Input Pincode" }]}
                style={data.posScreenStyles.addEditCustomerModal.formItem}
              >
                <Input
                  ref={refs.pincode}
                  value={getInputValue("pincode")}
                  onChange={onChangeInput}
                  onFocus={() => onFocusInput("pincode")}
                  id="sm-salesHistory-customer"
                  className="customerDetailsInput"
                  placeholder="Enter Pincode"
                  style={data.posScreenStyles.addEditCustomerModal.cutomerDetailsInput}
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Scrollbars>
    </>
  );
};

export default LegacyContactForm;
